import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import "./minutesSection.css";
import htmlParser from "html-react-parser";


export default function MinutesSection({minutesData}) {


  return (
    <>
      <div className="disclaimer">
        <Container>
          <p>{htmlParser(minutesData.disclaimer1)}</p>
          
          <p>{htmlParser(minutesData.disclaimer2)}</p>
        </Container>
      </div>
     </>
  );
}
